import { action, makeObservable, observable } from 'mobx';
import { DropdownOption, ProgramCountryLead, ProgramCountryNominationReviewer, ProgramRegion, RegionLead } from '../../models';

export class EditRegionalPageUiStore {
  @observable programRegions: ProgramRegion[] = [];

  @observable programCountryLeads: ProgramCountryLead[] = [];

  @observable programCountryNominationReviewers: ProgramCountryNominationReviewer[] = [];

  @observable regionLeads: RegionLead[] = [];

  @observable selectedEligibilityRuleCodes: string[] = [];

  @observable designationOptions: DropdownOption<string>[] = [];

  constructor() {
    makeObservable(this);
  }

  @action
  resetStates(): void {
    this.programRegions = [];
    this.programCountryLeads = [];
    this.programCountryNominationReviewers = [];
    this.regionLeads = [];
    this.selectedEligibilityRuleCodes = [];
    this.designationOptions = [];
  }

  @action
  setProgramRegions(programRegions: ProgramRegion[]): void {
    this.programRegions = programRegions;
  }

  @action
  setProgramCountryLeads(programCountryLeads: ProgramCountryLead[]): void {
    this.programCountryLeads = programCountryLeads;
  }

  @action
  setProgramCountryNominationReviewers(programCountryNominationReviewers: ProgramCountryNominationReviewer[]): void {
    this.programCountryNominationReviewers = programCountryNominationReviewers;
  }

  @action
  setRegionLeads(regionLeads: RegionLead[]): void {
    this.regionLeads = regionLeads;
  }

  @action
  setEligibilityRuleCodes(ruleCodes: string[]): void {
    this.selectedEligibilityRuleCodes = ruleCodes;
  }

  @action
  setDesignationOptions(designationOptions: DropdownOption<string>[]): void {
    this.designationOptions = designationOptions;
  }

  @action
  handleOnDesignationChange(updatedDesignations: string[]) {
    const designationCodes = this.designationOptions.map((option) => option.value);
    const nonDesignationCodes = this.selectedEligibilityRuleCodes.filter((code) => !designationCodes.includes(code));
    const updatedCodes = [...nonDesignationCodes, ...updatedDesignations];
    this.selectedEligibilityRuleCodes.splice(0, this.selectedEligibilityRuleCodes.length, ...updatedCodes)
  }
}
